// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3cca52ef","455":"7fd9299c","977":"f0f2b3a7"}[chunkId] + ".chunk.js";
};